import { InputHTMLAttributes, ChangeEvent } from 'react';
import styled from 'styled-components';

const CheckboxContainer = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const HiddenCheckbox = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

const StyledCheckbox = styled.div<{ $checked: boolean; $disabled?: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ $checked, theme }) =>
    $checked ? theme.colors.white : theme.colors.grey[300]};
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover:not(:$disabled) {
    border-color: ${({ theme }) => theme.colors.white};
  }
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};

  &::after {
    content: '';
    width: 4px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    opacity: ${({ $checked }) => ($checked ? 1 : 0)};
    transition: opacity 0.2s ease;
  }
`;

type Props = {
  checked: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
} & InputHTMLAttributes<HTMLInputElement>;

export const Checkbox = ({ checked, onChange, ...props }: Props) => {
  return (
    <CheckboxContainer>
      <HiddenCheckbox
        type='checkbox'
        checked={checked}
        onChange={onChange}
        {...props}
      />

      <StyledCheckbox $checked={checked} $disabled={props.disabled} />
    </CheckboxContainer>
  );
};
